var exports = {
  "nN": "copilotAnimationHolder__Oj2LO7",
  "Yf": "activate__7DDXf9",
  "FB": "copilotAnimation__BQtrEF",
  "uv": "preload__cyTP1E",
};

module.exports = exports;
